<template>
  <div>
    <el-button class="guide-btn" type="primary" :disabled="isConnect" :loading="loading" @click="connectMetaMask()">
      <img class="mm-logo" src="@/assets/logo/mm-logo.png">
      {{ btnText }}
    </el-button>
  </div>
</template>

<script>
import MetaMaskOnboarding from '@metamask/onboarding'
import metaMask from '@/layout/components/metaMaskInit/metaMask.js'
import {
  ensureTreasureNetwork,
  getCurrentChainId,
  getEthereumProvider,
  getNetworkErrorMessage,
  isExpectedChain
} from '@/utils/metamaskNetwork.js'

export default {
  name: 'MmLogin',
  data() {
    return {
      btnText: 'Connect MetaMask',
      isInstall: true,
      isConnect: false,
      loading: false,
      account: '',
      chainId: '',
      ethereumProvider: undefined,
      handleChainChanged: undefined
    }
  },
  created() {
    this.init()
    this.ethereumProvider = getEthereumProvider()
    if (!this.ethereumProvider) {
      return
    }

    this.ethereumProvider.autoRefreshOnNetworkChange = false
    this.handleChainChanged = (chainId) => {
      this.chainId = chainId
      if (!isExpectedChain(chainId)) {
        this.isConnect = false
      }
    }
    this.ethereumProvider.on('chainChanged', this.handleChainChanged)
  },
  beforeDestroy() {
    if (this.ethereumProvider && this.handleChainChanged) {
      this.ethereumProvider.removeListener('chainChanged', this.handleChainChanged)
    }
  },
  methods: {
    init() {
      this.isInstall = metaMask.isMetaMaskInstalled()
      if (this.isInstall) {
        this.btnText = 'Connect MetaMask'
      } else {
        this.btnText = 'Install MetaMask'
      }
    },
    async connectMetaMask() {
      if (!this.isInstall) {
        this.btnText = 'Onboarding in progress'
        const onboarding = new MetaMaskOnboarding()
        onboarding.startOnboarding()
      } else {
        this.loading = false
        this.btnText = 'Connect MetaMask'
        const joined = await this.joinNet()
        if (!joined) {
          return false
        }
        await this.getChainId()
        if (!isExpectedChain(this.chainId)) {
          this.$message.error('Failed to join the network!')
          return false
        }
        this.onClickConnect()
      }
    },
    async onClickConnect() {
      try {
        this.loading = true
        if (!this.ethereumProvider) {
          this.$message.error('Please install MetaMask first')
          this.loading = false
          return
        }
        await this.ethereumProvider.request({ method: 'eth_requestAccounts' })
        const accounts = await this.ethereumProvider.request({ method: 'eth_accounts' })
        if (!accounts[0]) {
          this.$message.error('Not able to get accounts')
          this.isConnect = false
        } else {
          this.account = accounts[0]
          this.isConnect = true
          this.$emit('success', this.account)
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.isConnect = false
      }
    },
    async joinNet() {
      try {
        await ensureTreasureNetwork(this.ethereumProvider)
        return true
      } catch (error) {
        this.loading = false
        this.$message.error(getNetworkErrorMessage(error))
        return false
      }
    },
    loginResult(res) {
      if (res === 'success') {
        this.btnText = 'Connected'
        this.isConnect = true
      } else {
        this.btnText = 'Connect MetaMask'
        this.isConnect = false
      }
      this.loading = false
    },
    async getChainId() {
      this.chainId = await getCurrentChainId(this.ethereumProvider)
    }
  }
}
</script>

<style lang="scss" scoped>
.mm-logo {
  margin-right: 0.1rem;
}
</style>
